import { createRouter, createWebHashHistory } from "vue-router";
import defaultRoutes from "./defaultRoutes.js";
import customRoutes from "./customRoutes.js";

const routes = [
  ...defaultRoutes, //  모든 프로젝트 공통 페이지
  ...customRoutes, // 프로젝트 전용 페이지
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    // 라우터 전환시 스크롤을 페이지 최상위로 이동
    return { top: 0 };
  },
});

export default router;
